import { Disclosure } from '@headlessui/react'
import { useRefinementList } from 'react-instantsearch';

const refinementClassNames = {
    root: 'toggle-panel pb-4 text-brand-neutral-700',
    item: 'py-2',
    checkbox: 'mr-4 border w-5 h-5 border-brand-blue-300 accent-brand-blue-300 focus:ring-0 rounded-none',
    label: 'flex items-center',
    selectedItem: 'text-brand-blue-500',
    labelText: 'font-light',
    count: 'hidden',
}

export function FilterPanel(props) {
    
    const heading = props?.heading ? props?.heading : null;
    const autoExpand = props?.expand ? true : false;

    const { items, refine } = useRefinementList(props);

    // https://headlessui.com/react/disclosure#component-api
    return (
        <Disclosure defaultOpen={autoExpand}>
            {({ open }) => (
            <div className="border-b border-brand-50">
                <Disclosure.Button className="w-full flex items-center justify-between cursor-pointer text-brand-neutral-900 hover:text-brand-blue-300">
                    <h4 className="py-5">{heading}</h4>
                    <svg className={open ? 'hidden' : 'w-6 h-auto fill-current'} xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"></path></svg>
                    <svg className={open ? 'w-6 h-auto fill-current' : 'hidden'} xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#000000" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128Z"></path></svg>
                </Disclosure.Button>
                <Disclosure.Panel>
                    <div className={refinementClassNames.root}>
                        <ul className="ais-RefinementList-list">
                        {items.map((item) => (
                            <li
                                key={item.value}
                                className={cx(refinementClassNames.item,item.isRefined && refinementClassNames.selectedItem)}
                            >
                                <label className={refinementClassNames.label}>
                                <input type="checkbox"
                                    className={refinementClassNames.checkbox}
                                    value={item.value}
                                    checked={item.isRefined}
                                    onChange={() => refine(item.value)}
                                />
                                    <span className={refinementClassNames.labelText}>{item.label}</span>
                                </label>
                            </li>
                        ))}
                        </ul>
                    </div>
                </Disclosure.Panel>
            </div>
            )}
        </Disclosure>
    )
}

function cx(...classNames) {
    return classNames.filter(Boolean).join(' ');
}
  